import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import SocialIcon from './SocialIcon';
import logo from '../../assets/logo/Logo svg file 3.svg';

import { ReactComponent as PhoneIcon } from '../../assets/logo/phone-icon.svg';

import { ReactComponent as LocationIcon } from '../../assets/footer/gridicons_location.svg';

// ✅ SVG imports - these should now be active
import { ReactComponent as InstagramIcon } from '../../assets/footer/ri_instagram-line.svg';
import { ReactComponent as LinkedinIcon } from '../../assets/footer/ri_linkedin-fill.svg';
import { ReactComponent as YouTubeIcon } from '../../assets/footer/line-md_youtube.svg';
import { ReactComponent as WhatsAppIcon } from '../../assets/footer/ic_baseline-whatsapp.svg';
import { ReactComponent as FacebookIcon } from '../../assets/footer/gg_facebook.svg';

// Constants for better maintainability
const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/profile.php?id=61553932716202",
  linkedin: "https://www.linkedin.com/company/rubaai-technologies/",
  youtube: "https://youtube.com/@moipay-d3n?si=XWFXKjTnNhO3NgRl",
  instagram: "https://www.instagram.com/rubaai_technologies/",
  whatsapp: "https://wa.me/94774443272"
  
};

const NAVIGATION_ITEMS = {
  home: '/',
  about: '/about',
  ourTeam: '/our-team',
  careers: '/careers',
  contactUs: '/contact-us',
  privacyPolicy: '/privacy-policy',
  termsofservice: '/Terms-of-service-screen'};

const COMPANY_INFO = {
  name: "Rubaai Technologies",
  tagline: "Financial Services",
  currentYear: new Date().getFullYear(),
  description: "Rubaai Technologies (Pvt) Ltd is a trusted digital payment gateway solution provider, delivering secure and efficient financial transaction services for individuals and businesses. We empower seamless payments through innovative technology, ensuring reliability, speed, and ease of use.",
  contact: {
    phone: "077 4443272",
    email: "careers@rubaai.net",
    address: "No 08, Thiruvalluvar Supermarket, Bustand Building, Mannar."
  }
};

// Main Footer Container
const FooterContainer = ({ children }) => (
  <Box
    component="footer"
    sx={{
      backgroundColor: '#000000',
      borderTop: '1px solid #333333',
      color: '#ffffff',
      padding: { 
        xs: '20px 20px 20px 20px',   // top 20px, right 20px, bottom 40px, left 20px
        md: '30px 40px 30px 40px',   // top 30px, right 40px, bottom 60px, left 40px
        lg: '40px 60px 40px 60px'    // top 40px, right 60px, bottom 80px, left 60px
      },
      
      
      
    }}
  >
   <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { 
            xs: '1fr', 
            md: '2fr 1fr 1fr 1.5fr',
            lg: '2.5fr 1fr 1fr 1.5fr'
          },
          gap: { xs: '40px', md: '60px' },
          alignItems: 'start'
        }}
      >
        {children}
      </Box>
    </Box>
  </Box>
);

// Company Info Section (Left Column)
const CompanySection = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '8px'
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Rubaai Logo"
        sx={{
          width: '115px',
          height: '124px',
          
aspectratio: 115/124,
        }}
      />
      <Box>
        <Typography
          variant="h6"
        sx={{
          color: '#FFFFFF',
fontfamily: "DM Sans",
fontsize: '32px',

fontweight: 800,
lineheight: '20px' /* 90% */
        }}
        >
          {COMPANY_INFO.name}
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 400,
            color: '#A6A0A0',
            fontFamily: "'DM Sans', sans-serif"
          }}
        >
          {COMPANY_INFO.tagline}
        </Typography>
      </Box>
    </Box>
    
    <Typography
      sx={{
        color: '#D9D9D9',
fontfamily: "DM Sans",
fontsize: '19px',
alignItems:'stretch',
fontweight: 300,
lineheight: '19px',/* 100% */
      }}
    >
      {COMPANY_INFO.description}
    </Typography>
  </Box>
);

// Quick Links Section
const QuickLinksSection = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: '#FFFFFF',
fontfamily: "DM Sans",
fontsize: '20px',

fontweight: 800,
lineheight: '18px' /* 90% */
        }}
      >
        Quick Links
      </Typography>
      
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
      >
        <FooterLink
          text="Home"
          onClick={() => handleNavigation(NAVIGATION_ITEMS.home)}
        />
        <FooterLink
          text="About us"
          onClick={() => handleNavigation(NAVIGATION_ITEMS.about)}
        />
        <FooterLink
          text="Our Team"
          onClick={() => handleNavigation(NAVIGATION_ITEMS.ourTeam)}
        />
        <FooterLink
          text="Careers"
          onClick={() => handleNavigation(NAVIGATION_ITEMS.careers)}
        />
        <FooterLink
          text="Contact Us"
          onClick={() => handleNavigation(NAVIGATION_ITEMS.contactUs)}
        />
       
        <FooterLink
          text="privacy Policy"
          onClick={() => handleNavigation(NAVIGATION_ITEMS.privacyPolicy)}
        />
        
        <FooterLink
          text="Terms of Service"
          onClick={() => handleNavigation(NAVIGATION_ITEMS.termsofservice)}
        />

        
      </Box>
    </Box>
  );
};

// Contact Us Section
const ContactSection = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }}
  >
    <Typography
      variant="h6"
        sx={{
          color: '#FFFFFF',
fontfamily: "DM Sans",
fontsize: '20px',

fontweight: 800,
lineheight: '18px' /* 90% */
        }}
    >
      Contact Us
    </Typography>
    
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}
    >
      <ContactItem
        icon={<PhoneIcon />}
        text={COMPANY_INFO.contact.phone}
        href={`tel:${COMPANY_INFO.contact.phone.replace(/\s/g, '')}`}
      />
      <ContactItem
        icon="✉️"
        text={COMPANY_INFO.contact.email}
        href={`mailto:${COMPANY_INFO.contact.email}`}
      />
      <ContactItem
        icon={<LocationIcon />}
        text={COMPANY_INFO.contact.address}
      />
    </Box>
  </Box>
);

// Stay Updated Section (Right Column)
const StayUpdatedSection = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }}
  >
    <Typography
      variant="h6"
        sx={{
          color: '#FFFFFF',
fontfamily: "DM Sans",
fontsize: '20px',

fontweight: 800,
lineheight: '18px' /* 90% */
        }}
    >
      Stay Updated
    </Typography>
    
    <Typography
      sx={{
        color: '#FFFFFF',
fontfamily: "DM Sans",
fontsize: '20px',

fontweight: '300',
lineheight: '24px' /* 120% */
      }}
    >
      Follow to recieve updates on New Products and Career Opportunity
    </Typography>
    
    <SocialLinksContainer />
  </Box>
);

// Reusable Components
const FooterLink = ({ text, onClick }) => (
  <Typography
    onClick={onClick}
    sx={{
      color: '#9CA3AF',
      fontSize: '16px',
      cursor: onClick ? 'pointer' : 'default',
      transition: 'color 0.3s ease',
      fontFamily: "'Inter', sans-serif",
      '&:hover': {
        color: onClick ? '#ffffff' : '#9CA3AF'
      }
    }}
  >
    {text}
  </Typography>
);

const ContactItem = ({ icon, text, href }) => (
  <Box
    component={href ? 'a' : 'div'}
    href={href}
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      color: '#9CA3AF',
      textDecoration: 'none',
      cursor: href ? 'pointer' : 'default',
      transition: 'color 0.3s ease',
      '&:hover': {
        color: href ? '#ffffff' : '#9CA3AF'
      }
    }}
  >
    <Box
      sx={{
        fontSize: '16px',
        marginTop: '2px',
        minWidth: '20px'
      }}
    >
      {icon}
    </Box>
    <Typography
      sx={{
        fontSize: '16px',
        lineHeight: '22px',
        fontFamily: "'Inter', sans-serif"
      }}
    >
      {text}
    </Typography>
  </Box>
);

const SocialLinksContainer = () => (
  <Box
    sx={{
      display: 'flex',
      gap: '16px',
      alignItems: 'center'
    }}
  >
    <SocialIcon icon={<FacebookIcon />} link={SOCIAL_LINKS.facebook} />
    <SocialIcon icon={<InstagramIcon />} link={SOCIAL_LINKS.instagram} />
    <SocialIcon icon={<LinkedinIcon />} link={SOCIAL_LINKS.linkedin} />
    <SocialIcon icon={<WhatsAppIcon />} link={SOCIAL_LINKS.whatsapp} />
    <SocialIcon icon={<YouTubeIcon />} link={SOCIAL_LINKS.youtube} />
  </Box>
);

// Copyright Section
const CopyrightSection = () => (
  <Box
  sx={{
    maxWidth: '800px',
    margin: '0 auto',
    //borderTop: '1px solid #333333',
    marginTop: '35px',
    paddingTop: '10px',
    paddingBottom: '20px',  // <-- add this for extra space
    textAlign: 'center'
  }}
>

    <Typography
      sx={{
        fontSize: '14px',
        color: '#6B7280',
        fontFamily: "'Inter', sans-serif"
      }}
    >
      ©{COMPANY_INFO.currentYear} Rubaai. Created by{' '}
      <Box
        component="span"
        sx={{
          color: '#ffffff',
          fontWeight: 500
        }}
      >
        RubaaiTechnologies
      </Box>
    </Typography>
  </Box>
);

/**
 * Main Footer Component
 * 
 * Recreated to match the Figma design exactly with:
 * - Company info with logo and description
 * - Quick Links navigation
 * - Contact information with icons
 * - Stay Updated section with social media
 * - Copyright footer
 * - Responsive grid layout
 */
const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#000000',
        color: '#ffffff',
        fontFamily: "'Inter', sans-serif"
      }}
    >
      <FooterContainer>
        <CompanySection />
        <QuickLinksSection />
        <ContactSection />
        <StayUpdatedSection />
      </FooterContainer>
      <CopyrightSection />
    </Box>
  );
};

export default Footer;

